










import Vue from 'vue';
import Component from 'vue-class-component';
import { Prop, Emit } from 'vue-property-decorator';

@Component({})
export default class SingleLineCriteria extends Vue {
    @Prop() public criteriaStr: string;
    @Prop() public printVersion: boolean;

    @Emit()
    public change(printVersion: boolean) {
        // empty
    }

    public togglePrintVersion() {
        this.change(!this.printVersion);
    }
}
